import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const Elimination = createSvgIcon(
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2074_7788)">
      <rect x="6.00146" y="8.82874" width="4" height="24" transform="rotate(-45 6.00146 8.82874)" fill="currentColor" />
      <rect x="9.00024" y="25.8292" width="4" height="24" transform="rotate(-135 9.00024 25.8292)" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_2074_7788">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'Elimination'
);
